import Core from "@/core/Core";
import ContactsDAO from "@/domains/Contacts/ContactsDAO";

class ContactsService {
	static contactTypes = reactive([
		{
      id: "phone",
      name: "Телефон",
      toString() {return this.name},
    },
		{
      id: "skype",
      name: "Skype",
      toString() {return this.name},
    },
    {
      id: "email",
      name: "Email",
      toString() {return this.name},
    },
	]);

	static getTypeById(id: string | null) {
		return this.contactTypes.find((item) => item.id === id) || null;
	}

	static async delete(id: number): Promise<boolean> {
		const response = await ContactsDAO.delete(id);

		if (response.ok) {
			Core.showNotification.success("Контакт успешно удалён");
		} else {
			Core.showNotification.error("Ошибка удаления контакта");
		}

		return response.ok;
	}

	static async create(personId: number, contact: any): Promise<boolean> {
		const response = await ContactsDAO.create(personId, contact);

		if (!response.ok) {
			Core.showNotification.error("Ошибка создания контакта");
		}

		return response.ok;
	}

	static async update(contact: any): Promise<boolean> {
		const response = await ContactsDAO.update(contact);

		if (!response.ok) {
			Core.showNotification.error("Ошибка обновления контакта");
		}

		return response.ok;
	}
}

export default ContactsService;
